export default "__VITE_ASSET__aDqeKIWB__"